// Added by Sejune Oh on 2020-04-24
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Style
import { customStyles as RadsScorepercentageview } from '@/components/worklist/RadsScorePercentageView'
import { customStyles as HistogrambarchartStyles } from '@/components/worklist/HistogramBarChart'
import { customStyles as StatisticexportbuttonStyles } from '@/components/worklist/StatisticExportButton'
import { customStyles as StatisticshistogramStyles } from '@/components/worklist/StatisticsHistogram'

type ComponentTypes = 'statisticexportbutton' | 'histogrambarchart'  | 'radsscorepercentageview' | 'statisticshistogram'

export type LCSStatisticStyleTypes = {
  [key in ComponentTypes]: Record<string, any>
}

export const LCSStatisticStyles: LCSStatisticStyleTypes = {
  statisticexportbutton: StatisticexportbuttonStyles,
  histogrambarchart: HistogrambarchartStyles,
  radsscorepercentageview: RadsScorepercentageview,
  statisticshistogram: StatisticshistogramStyles
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Wrapper Component
export { default as LCSStatisticWrapper } from './LCSStatisticWrapper'
export * from './LCSStatisticWrapper'
